import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

const BASE = `${Config.nodeSiteUrl}v1/jobs`;

export interface JobMetadata {
  jobName?: string;
  description: string;
  warning?: string;
  defaultCron?: string;
  touches?: string[];
  configurable?: boolean;
  configSchema?: string;
}

export interface JobScheduleRow {
  id: number;
  jobKey: string;
  jobName: string;
  cronExprUTC: string;
  isEnabled: number;
  lastRunAt: string | null;
  lastStatus: "SUCCESS" | "FAILED" | null;
  config: Record<string, unknown> | null;
  createdAt: string | null;
  updatedAt: string | null;
  hasRunner: boolean;
  metadata: JobMetadata | null;
  notInDb?: boolean;
}

export async function listJobSchedules(): Promise<JobScheduleRow[]> {
  const res = await myAxios.get<{ success: boolean; schedules: JobScheduleRow[] }>(
    `${BASE}/schedules`,
  );
  return res.data.schedules ?? [];
}

interface UpdateScheduleResponse {
  success: boolean;
  schedule: JobScheduleRow;
}

export async function updateJobSchedule(
  jobKey: string,
  patch: {
    cronExprUTC?: string;
    isEnabled?: boolean;
    config?: Record<string, unknown> | null;
  },
): Promise<JobScheduleRow> {
  const res = await myAxios.patch(
    `${BASE}/schedules/${encodeURIComponent(jobKey)}`,
    patch,
  );
  const data = res.data as UpdateScheduleResponse;
  return data.schedule;
}

export async function reloadJobSchedules(): Promise<void> {
  await myAxios.post(`${BASE}/schedules/reload`);
}

export async function triggerJobSchedule(jobKey: string): Promise<void> {
  await myAxios.post(`${BASE}/schedules/${encodeURIComponent(jobKey)}/trigger`);
}

export interface SmsDeliverySeed {
  config: Record<string, unknown> | null;
  row: { id: number; name: string } | null;
}

export async function fetchSmsDeliverySeed(): Promise<SmsDeliverySeed> {
  const res = await myAxios.get<{
    success: boolean;
    config: Record<string, unknown> | null;
    row: { id: number; name: string } | null;
  }>(`${BASE}/schedules/sms-delivery/seed`);
  return { config: res.data.config ?? null, row: res.data.row ?? null };
}
